import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "../../store";
import React, {useEffect, useState} from "react";
import {withExplorer} from "../../layout/Explorer";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';
import Form from "../../lib/appfuse-react/component/Form";
import {
    Checkbox, Divider,
    FormControlLabel,
    FormGroup, FormLabel,
    Grid,Radio, RadioGroup,
    TextField, useTheme
} from "@material-ui/core";
import Button from "../../lib/appfuse-react/component/Button";
import Box from "../../lib/appfuse-react/component/Box";
import i18n from "../../lib/appfuse-react/core/i18n";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import registrationService from "../../service/iam/registrationService";
import AddressThreeColumn from "../../component/AddressThreeColumn";
import {selectRegistrationForm, setRegistrationForm} from "../../reducer/iam/registrationReducer";
import Expander from "../../lib/appfuse-react/component/Expander";
import Space from "../../lib/appfuse-react/component/Space";
import DataTable, {DataColumn} from "../../lib/appfuse-react/component/DataTable";
import FileField from "../../lib/appfuse-react/component/FileField";
import useDimension from "../../lib/appfuse-react/hook/useDimension";
import useRouter from "../../lib/appfuse-react/hook/useRouter";
import Paper from "../../lib/appfuse-react/component/Paper";
import Forms, {AddAction, RemoveAction} from "../../lib/appfuse-react/component/Forms";
import {HomeImage} from "../Home";
import code from "../../lib/appfuse-react/core/code";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import lang from "../../lib/appfuse-react/core/lang";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import utilService from "../../service/util/utilService";
import Radios from "../../component/Radios/Radios";
import applicationSurveyWithAnswer from "../../mock/applicationDraft/applicationSurveyWithAnswer";
import NumberField from "../../lib/appfuse-react/component/NumberField";

const useStyles = makeStyles((theme) => ({
    transparent: {
        backgroundColor: 'transparent'
    },
    whiteSpace:{
        whiteSpace:'break-spaces'
    },
    whiteSpacePreWrap:{
        whiteSpace:'pre-wrap'
    },
    link: {
        textDecoration: 'underline',
        textUnderlinePosition: 'under',
        cursor: 'pointer',
        marginLeft:'1em'
    }
}));

const STEPS = ['Registration Description', 'Applicant Basic Info', 'Assessment Place Basic Info', 'Assessment Product Info','Statement', 'Verify your email address'];
const FORMS = [RegistrationForm_0, RegistrationForm_1, RegistrationForm_2, RegistrationForm_3, RegistrationForm_4, RegistrationForm_5];
const validateData = [
    [],
    ['individual', "companyName", "personInCharge", 'taxIdNo', 'companyAddress', 'contactPerson', 'contactPersonTitle', 'email', 'contactPhone', 'contactMobile', 'fax', 'mailingAddress', 'partnerCustomers', 'partnerCustomersDesc', 'registrationCertificates'],
    ['assessmentPlaces'],
    ['estimatedProductNumber', 'allVegetarian', 'assessmentStandards'],
    ['confirmStatement1', 'confirmStatement2'],
    []
];
const addressValidateData = ['country', 'zip', 'county', 'town', 'street'];
const assessmentPlaceValidateData = ['name', 'assessmentCategory', 'factoryRegistrationNo', 'relationshipWithApplicant', 'relationshipWithApplicantDesc', 'address', 'productionLines',
    'entrustExternalUnit', 'externalUnitName', 'externalUnitCooperativeContent', 'externalUnitContact', 'causeProductRisk', 'causeProductRiskDesc'];

function getStepContent(step) {
    switch (step) {
        case 0:
            return `Notes on registration`;
        case 1:
            return `Please fill in the basic information of the applicant unit.`;
        case 2:
            return `Please fill in the expected number of products to be applied for and the evaluation criteria for the application.`;
        case 3:
            return `Instructions for registration step 3.`;
        case 4:
            return `Please check the confirmation statement`;
        case 5:
            return `Verify email description ...`
        default:
            return 'Unknown step';
    }
}

function Registration(props) {
    const router = useRouter();
    const [activeStep, setActiveStep] = useState(0);
    const value = useSelector(selectRegistrationForm);
    const counties = useSelector(selectCounty);
    const {individual} = value;
    const dispatch = useDispatch();
    const prompt = usePrompt();

    useEffect(() => {
        (async () => {
            const newValue = {...value};
            if(!value.companyAddress) {
                newValue.companyAddress = {country: 'TW'};
            }
            if(!value.mailingAddress) {
                newValue.mailingAddress = {country: 'TW'};
            }
            if(lang.isUndefined(value.individual)) {
                newValue.individual = false;
            }
            dispatch(setRegistrationForm(newValue));

            if(lang.isEmpty(counties)) {
                dispatch(setCounty(await utilService.findAllCounties()));
            }
            await code.assert('country', 'relatedPartner', 'assessmentStandard');
        })()
    }, [])

    const handleChange = (event) => {
        dispatch(setRegistrationForm(event.value));
    };


    const getValidateData = () => {
        let result = {};
        for(let i=0; i<=activeStep; i++) {
            result = validateData[i].reduce((result, key) => ({...result, [key]: (lang.isNotUndefined(value[key])? value[key] : null)}), result);
        }
        if(activeStep > 0) {
            if(result.companyAddress) {
                result.companyAddress = addressValidateData.reduce((accumulator, key) => ({...accumulator, [key]: result.companyAddress[key] || null}), {});
            }
            if(result.mailingAddress) {
                result.mailingAddress = addressValidateData.reduce((accumulator, key) => ({...accumulator, [key]: result.mailingAddress[key] || null}), {});
            }
        }
        if(activeStep > 1) {
            if(result.assessmentPlaces) {
                result.assessmentPlaces = result.assessmentPlaces.map(item => assessmentPlaceValidateData.reduce((accumulator, key) => ({...accumulator, [key]: item[key] || null}), {}));
            }
        }
        if (result.partnerCustomers && result.partnerCustomers.length === 0) {
            result.partnerCustomers = null;
        }
        if (result.assessmentStandards && result.assessmentStandards.length === 0) {
            result.assessmentStandards = null;
        }

        return result;
    };
    const validate = async () => {
        try {
            await registrationService.validate(getValidateData());
            return true;
        } catch (e) {
            const dictionary = {
                companyName: individual? "Customer User Name" : "Company Name", personInCharge: 'Person In Charge', taxIdNo: (individual) ? "ID Number" : "Tax ID No", companyAddress: (individual) ? "Permanent Address" : "Company Address",
                contactPerson: 'Contact Person', contactPersonTitle: 'Title of Contact Person', contactPhone: 'Contact Phone No. with ext', contactMobile: 'Contact Mobile No.', fax: 'Fax No.', mailingAddress: 'Mailing Address',
                partnerCustomers: 'Are you already a customer of the company listed on the right', county: 'City', town: 'District', assessmentPlaces: 'Assessment Place', assessmentCategory: 'Assessment Category', factoryRegistrationNo: 'Factory Registration No.',
                relationshipWithApplicant: 'Relationship With Applicant', relationshipWithApplicantDesc: 'Description of relationship with applicant',entrustExternalUnit:'Have commissioned an external unit to perform part of the production operation',
                address: 'Address Of Assessment Place', productionLine:'Production Line Description', productionProcess:'Briefly describe the production process of the applied product',externalUnitName: 'Unit Name', externalUnitContact: 'Contact Person',
                externalUnitCooperativeContent: 'Cooperative Content', causeProductRisk: 'Cause Product Risk', causeProductRiskDesc: 'Please Specify', name: 'Assessment Place Name', estimatedProductNumber: "Estimated Product Number", allVegetarian: 'Are all the products applied for vegetarian food',
                assessmentStandards: "Apply Assessment Criteria", confirmStatement1: 'Confirm Statement', confirmStatement2: 'Confirm Statement', registrationCertificates: (individual? "Photocopy of the front and back of the ID card" : "Company/Business Registration Certificate")
            };
            prompt.alert(e, {title:'Invalid input. Please check your input and try again.', dictionary});
            return false;
        }
    };

    const handleNext = async () => {
        const validateSuccess = await validate();
        if (validateSuccess) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleBack = () =>
        setActiveStep((prevActiveStep) => prevActiveStep - 1);


    const handleComplete = async () => {
        try {
            await registrationService.complete(value);
            prompt.confirm('You Have Successfully Registered. We will complete the review as soon as possible and notify the result by email.', {
                title: 'Welcome to Assessment Service Web',
                onAction: () => router.login()
            });
            dispatch(setRegistrationForm({}));
        } catch (e) {
            prompt.alert(e);
        }
    }

    const title = STEPS[activeStep];
    const description = getStepContent(activeStep);
    const Form = FORMS[activeStep];

    return (
        <Paper className="app-registration" position="relative" fullWidth fullHeight >
            <Box position="absolute" top={0} left={0} fullWidth fullHeight backgroundColor="black" backgroundOpacity={0.5} >
                <HomeImage />
            </Box>
            <Box fullHeight fullWidth display="flex" justifyContent="center" alignItems="center" position="relative" >
                <Box display="flex" width="90%" minWidth="70rem" gap={3}>
                    <Form value={value} onChange={handleChange} onValidate={validate}
                          onNext={handleNext} onBack={handleBack}
                          title={title} description={description} onComplete={handleComplete} />
                    <Paper width="25rem" backgroundColor="paper" backgroundOpacity={0.94}>
                        <RegistrationStepper activeStep={activeStep} />
                    </Paper>
                </Box>
            </Box>
        </Paper>
    );
}

function RegistrationForm_0(props) {
    const { title, description } = props;
    const theme = useTheme();
    const router = useRouter();
    const handleSignInInstead = () => router.login();
    return (
        <Paper padding={3} display="flex" flexDirection="column" gap={1} backgroundOpacity={0.94} borderRadius={1} fullWidth  >
            <Typography variant="h5">{ i18n.translate(title)}</Typography>
            <Typography>{i18n.translate(description)}</Typography>
            <Box maxHeight={`calc(40vh - ${theme.mixins.toolbar.minHeight}px)`} overflow="auto" >
                <DataTable data={registrationDescriptions} dense>
                    <DataColumn accessor="code"/>
                    <DataColumn accessor="name"/>
                </DataTable>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={2}>
                <Button text="Sign in instead" color="secondary" onClick={handleSignInInstead} />
                <Button text="Start registration" variant="contained" color="primary" onClick={props.onNext} />
            </Box>
        </Paper>
    )
}

function RegistrationForm_1(props) {
    const theme = useTheme();
    const dimension = useDimension();
    const { value, title, description } = props;
    const {partnerCustomers=[]} = value;
    const noneIdx = partnerCustomers.findIndex(customer => customer === 'none');
    const checkboxes =  code.get('relatedPartner').map((customer, index) => {
        const options = {};
        if (value.partnerCustomers?.length > 0 ) {
            if (noneIdx === -1 && customer.value === 'none') {
                options.disabled = true;
            } else if (noneIdx !== -1)  {
                if (customer.value !== 'none') {
                    options.disabled = true;
                }
            }
        }
        const control = <Checkbox  {...options} />;
        return  <FormControlLabel key={index} name="partnerCustomers" value = {customer.value} control={control} label={i18n.translate(customer.text)}/>;
    });

    const {individual} = value;
    //欄位名稱依個人或公司而不同
    const companyAddressLabel = (individual) ? "Permanent Address" : "Company Address" ;
    const customerNameLabel = (individual) ? "Customer User Name" : "Company Name" ;
    const certificateLabel = (individual) ? "Photocopy of the front and back of the ID card" : "Company/Business Registration Certificate";
    const taxIdNoLabel = (individual) ? "ID Number" : "Tax ID No" ;
    const mailingAddressSameAs = i18n.translate('Same As') + i18n.translate(companyAddressLabel);

    const handleChange = ({value, change}) => {
        if(change.sameAsCompanyAddress) {
            value.mailingAddress = Object.assign({}, value.companyAddress);
        }
        props.onChange(new UserEvent({value}));
    }

    return (
        <Paper padding={3} display="flex" flexDirection="column" gap={1} backgroundOpacity={0.94} borderRadius={1} fullWidth >
            <Typography variant="h5">{ i18n.translate(title)}</Typography>
            <Typography>{i18n.translate(description)}</Typography>
            <Box overflowY='auto' overflowX='hidden'>
                <Form value={props.value} onChange={handleChange}
                      maxHeight={`calc(70vh - ${theme.mixins.toolbar.minHeight}px)`}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormGroup row>
                                <FormControlLabel name="individual" control={<Checkbox />} label="Individual" />
                            </FormGroup>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="companyName" label={customerNameLabel} variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="personInCharge" label="Person In Charge" variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="taxIdNo" label={taxIdNoLabel} variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <AddressThreeColumn name="companyAddress" subtitle={companyAddressLabel} required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="contactPerson" label="Contact Person" variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="contactPersonTitle" label="Title of Contact Person" variant="outlined"
                                       fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="email" label="Email" variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="contactPhone" label="Contact Phone No. with ext" variant="outlined"
                                       helperText='Contact Phone No with ext Helper Text' fullWidth required/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="contactMobile" label="Contact Mobile No." variant="outlined" helperText='Contact Mobile No Helper Text' fullWidth/>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="fax" label="Fax No." variant="outlined" helperText='Fax No Helper Text' fullWidth/>
                        </Grid>
                        <Grid item xs={12}>
                            <Box display="column">
                                <Box display="flex"  alignItems="center" gap={2} marginBottom={-1}>
                                    <Typography variant="subtitle1" gutterBottom color="textSecondary">
                                        {i18n.translate('Mailing Address')}
                                    </Typography>
                                    <FormGroup row>
                                        <FormControlLabel name="sameAsCompanyAddress" control={<Checkbox />} label={mailingAddressSameAs} />
                                    </FormGroup>
                                </Box>
                                <AddressThreeColumn name="mailingAddress" subtitle="Mailing Address" withTitle={false} required/>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <FormLabel component="legend" required>{i18n.translate('Are you already a customer of the company listed on the right')}</FormLabel>
                            <FormGroup row>
                                {checkboxes}
                            </FormGroup>
                        </Grid>
                        {
                            partnerCustomers?.includes("santaCruz") &&
                            <Grid item xs={12}>
                                <TextField name={"partnerCustomersDesc"} label={"Partner Customers Other Desc"} variant={"outlined"} fullWidth required/>
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <FileField name="registrationCertificates" variant="outlined" fullWidth label={certificateLabel} height={dimension.formControlHeight() * 1} multiple required/>
                        </Grid>
                    </Grid>
                </Form>
            </Box>
            <Box display="flex" justifyContent="space-between" marginTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext} />
            </Box>
         </Paper>

    )
}

function RegistrationForm_2(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [index, setIndex] = useState(0);
    const {title, description, onValidate} = props;
    const assessmentCategory = {'assessmentCategory':'processedFood', address: {country: 'TW'}};
    const {assessmentPlaces =[assessmentCategory], individual, companyAddress={}} = props.value;

    useEffect(() => {
        (async () => {
            await code.assert('assessmentCategory', 'relationshipWithApplicant');
        })()
    }, [])

    const handleOpenAssessmentPlace = (index) => async () => {
        if (await onValidate()) {
            setIndex(index);
        }
    }

    const handleDelete = (index) => event => {
        const newAssessmentPlaces = [...assessmentPlaces];
        newAssessmentPlaces.splice(index, 1);
        const value = {...props.value, assessmentPlaces:newAssessmentPlaces};
        props.onChange(new UserEvent({value}));
        setIndex(newAssessmentPlaces.length - 1);
    };

    const otherTitles = assessmentPlaces.map((assessmentPlace, index) => {
        return (
            <div>
                <Space spacing={2}/>
                    <Box display='flex' alignItems="center">
                        <Typography className={classes.link} variant="h6" color="primary" onClick={handleOpenAssessmentPlace(index)}>{assessmentPlace.name}</Typography>
                        <Button icon="delete" color="secondary" variant="icon" onClick={handleDelete(index)} size="small" />
                    </Box>
            </div>
            )
    });

    //目前的評鑑場所
    const assessmentPlace = assessmentPlaces[index] || {id:index};
    const assessmentPlaceName = assessmentPlace.name;

    const handleChange = event => {
        const assessmentPlace = event.value;
        const newAssessmentPlaces = [...assessmentPlaces];
        newAssessmentPlaces[index] = assessmentPlace;
        const value = {...props.value, assessmentPlaces:newAssessmentPlaces};
        props.onChange(new UserEvent({value}));
    }

    const handleMoreAssessmentPlace = async (event) => {
        const validateSuccess = await onValidate();
        if (validateSuccess) {
            const index = assessmentPlaces.length;
            setIndex(index);
            const newAssessmentPlace = {name:'new', 'assessmentCategory':'processedFood', address: {country: 'TW'}};
            const newAssessmentPlaces = [...assessmentPlaces];
            newAssessmentPlaces.push(newAssessmentPlace);
            const value = {...props.value, assessmentPlaces:newAssessmentPlaces};
            props.onChange(new UserEvent({value}));
        }
    };

    return (
        <Paper padding={3} display="flex" flexDirection="column" gap={1} backgroundOpacity={0.94} borderRadius={1} fullWidth>
            <Box display="flex" gap={1} alignItems="baseline">
                <Typography variant="h5">{ i18n.translate(title)}</Typography>
                {/*顯示評鑑場所名稱*/}
                {assessmentPlaces.length > 1 && otherTitles}
            </Box>
            <Typography>{i18n.translate(description)}</Typography>
            {/*form 單獨scroll*/}
            <Box maxHeight={`calc(70vh - ${theme.mixins.toolbar.minHeight}px)`} overflowY="auto" overflowX='hidden' paddingTop={1}>
              <AssessmentPlaceInfo value={assessmentPlace} onChange={handleChange} individual={individual} companyAddress={companyAddress}/>
            </Box>
            <Box display="flex"  paddingTop={2}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Expander/>
                { assessmentPlaceName && <Button text="More Assessment Place" onClick={handleMoreAssessmentPlace}  color="primary"/>}
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext}/>
            </Box>
        </Paper>
    )
}


function RegistrationForm_3(props) {
    const theme = useTheme();
    const { value, title, description } = props;

    useEffect(() => {
        (async () => {
            await code.assert('whether');
        })()
    }, [])

    return (
        <Paper padding={3} display="flex" flexDirection="column" gap={1} backgroundOpacity={0.94} borderRadius={1} fullWidth >
            <Typography variant="h5">{ i18n.translate(title)}</Typography>
            <Typography>{i18n.translate(description)}</Typography>
            <Form value={value} onChange={props.onChange} marginTop={2}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <NumberField name="estimatedProductNumber" label="Estimated Product Number" variant="outlined" min={0} fullWidth required/>
                    </Grid>
                    <Grid item xs={4}>
                        <SelectField name='allVegetarian' label="Are all the products applied for vegetarian food" code='whether' variant='outlined' required/>
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel component="legend">  {i18n.translate('Apply Assessment Criteria *')}</FormLabel>
                        <FormGroup row>
                            {code.get('assessmentStandard').map((standard) => (
                                <FormControlLabel name="assessmentStandards" value = {standard.value} control={<Checkbox/> } label={i18n.translate(standard.text)}/>
                            ))}
                        </FormGroup>
                    </Grid>
                </Grid>
            </Form>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={props.onNext}/>
            </Box>

        </Paper>
    )
}

function AssessmentPlaceInfo(props) {
    const {value={}, companyAddress={}} = props;
    const {entrustExternalUnit, relationshipWithApplicant, productionLines=[]} = value;

    const handleChangeProductionLines = event => {
        let productionLines = event.value;
        if(productionLines && productionLines.length === 0) {
            productionLines = null;
        }
        const newValue = {...value, productionLines};
        props.onChange(new UserEvent({value: newValue}));
    }

    //欄位名稱依個人或公司而不同
    const {individual} = props;
    const companyAddressLabel = (individual) ? "Permanent Address" : "Company Address" ;
    const mailingAddressSameAs = i18n.translate('Same As') + i18n.translate(companyAddressLabel);

    const handleChange = ({value, change}) => {
        if(change.sameAsCompanyAddress) {
            value.address = companyAddress;
        }
        if (lang.isNotUndefined(change.relationshipWithApplicant) && change.relationshipWithApplicant !== 'others') {
            value.relationshipWithApplicantDesc = null;
        }
        if (change.entrustExternalUnit === 'N') {
            value.externalUnitName = null;
            value.externalUnitContact = null;
            value.externalUnitCooperativeContent = null;
            value.causeProductRisk = null;
            value.causeProductRiskDesc = null;
        }
        props.onChange(new UserEvent({value}));
    }

    return (
        <Form value={props.value} onChange={handleChange}>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <TextField name="name" label="Assessment Place Name" variant="outlined" fullWidth required
                    helperText="The name of the production site ..."/>
                </Grid>
                <Grid item xs={4}>
                    <SelectField name="assessmentCategory" label="Assessment Category" code='assessmentCategory' variant="outlined" disabled fullWidth/>
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4}>
                    <TextField name="factoryRegistrationNo" label="Factory Registration No." variant="outlined" fullWidth/>
                </Grid>
                <Grid item xs={4}>
                    <SelectField name="relationshipWithApplicant" label="Relationship With Applicant" code='relationshipWithApplicant' variant="outlined" required />
                </Grid>
                {
                    (relationshipWithApplicant) && relationshipWithApplicant === 'others' &&
                    <Grid item xs={4}>
                         <TextField name="relationshipWithApplicantDesc" label="Description of relationship with applicant"variant="outlined" fullWidth required/>
                    </Grid>
                }
                <Grid item xs={12}>
                    <Box display="column">
                        <Box display="flex"  alignItems="center" gap={2} marginBottom={-1}>
                            <Typography variant="subtitle1" gutterBottom color="textSecondary">
                                {i18n.translate("Address Of Assessment Place") + ' *'}
                            </Typography>
                            <FormGroup row>
                                <FormControlLabel name="sameAsCompanyAddress" control={<Checkbox />} label={mailingAddressSameAs} />
                            </FormGroup>
                        </Box>
                        <AddressThreeColumn name="address" subtitle="Mailing Address" withTitle={false} required/>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <ProductionLines data={productionLines} onChange={handleChangeProductionLines} />
                </Grid>
                <Grid item xs={12}>
                    <Radios name='entrustExternalUnit' title='Have commissioned an external unit to perform part of the production operation' required code='whether'/>
                </Grid>
                <Grid item xs={12}>
                    <Box display={ (entrustExternalUnit && entrustExternalUnit ==='Y') ? "" : "none"}>
                         <ExternalUnit value={props.value} onChange={props.onChange}/>
                    </Box>
                </Grid>
            </Grid>

        </Form>
    )
}

function ProductionLines(props) {
    const {data} = props;

    return (

        <Box>
            <Box marginTop={0.5}>
                <Divider variant="fullWidth" />
            </Box>
            <Box display="flex" alignItems="center" marginTop={1} marginBottom={1}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Typography>{i18n.translate('Production Line Description')} *</Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography>{i18n.translate('Briefly describe the production process of the applied product')} *</Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box marginBottom={1}>
                <Divider variant="fullWidth" />
            </Box>
            <Forms value={data} onChange={props.onChange} divider={false} gap={1}>
                <Grid container spacing={1}>
                    <Grid item xs={3}>
                        <TextField name="productionLine" variant="outlined" fullWidth required size="small"/>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField name="productionProcess" variant="outlined" fullWidth required size="small" />
                    </Grid>
                    <Grid xs={1} item>
                        <Box display="flex" gap={1} alignItems="center" fullHeight>
                            <RemoveAction><Button icon="clear" size="small" variant="icon" /></RemoveAction>
                            <AddAction><Button icon="add" size="small" variant="icon" /></AddAction>
                        </Box>
                    </Grid>
                </Grid>
            </Forms>
            <Box marginTop={1} display="flex" flexDirection="column">
                <Typography variant="caption" color="textSecondary">{i18n.translate('Helper Text of Production Line Description')}</Typography>
                <Typography variant="caption" color="textSecondary">{i18n.translate('Brief Production Process Helper Text')}</Typography>
            </Box>
        </Box>
    )

}

function ExternalUnit(props) {
    const {causeProductRisk} = props.value;

    const handleChange = event => {
        const {value} = event;
        if (event.change.causeProductRisk === 'N') {
            value.causeProductRiskDesc = null;
        }
        props.onChange(new UserEvent({value}));
    }

    return (
        <Form value={props.value} onChange={handleChange}>
            <Grid container spacing={2} >
                <Grid item xs={4}>
                    <TextField name="externalUnitName" label="Unit Name" variant="outlined" fullWidth required/>
                </Grid>
                <Grid item xs={8}>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <TextField name="externalUnitContact" label="Contact Person" variant="outlined" fullWidth required/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField name="externalUnitCooperativeContent" label="Cooperative Content" variant="outlined" fullWidth required/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box paddingX={1.5} marginTop={-1.5}>
                        <Typography variant="caption" color="textSecondary">{i18n.translate('Please give details, including technical support...')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <Radios name='causeProductRisk' title='Cause Product Risk' required code='whether' />
                </Grid>
                <Grid item xs={8}>
                    <Box display={causeProductRisk && causeProductRisk==='Y' ? "" : "none"}>
                        <TextField name="causeProductRiskDesc" label="Please Specify" variant="outlined" required fullWidth/>
                    </Box>
                </Grid>
            </Grid>

        </Form>
    )
}

function RegistrationForm_4(props) {
    const {value, title, description} = props;
    const theme = useTheme();

    return (
        <Paper padding={3} display="flex" flexDirection="column" gap={1} backgroundOpacity={0.94} borderRadius={1} fullWidth>
            <Typography variant="h5">{i18n.translate(title)}</Typography>
            <Typography>{i18n.translate(description)}</Typography>
            <Form value={value} onChange={props.onChange} maxHeight={`calc(70vh - ${theme.mixins.toolbar.minHeight}px)`} overflow="auto">
                <Box display="flex" flexDirection="column" gap={2} paddingTop={2} paddingBottom={2}>
                    <FormControlLabel
                        control={<Checkbox/>}
                        name="confirmStatement1"
                        label={i18n.translate('Statement1')}
                    />
                    <FormControlLabel
                        control={<Checkbox/>}
                        name="confirmStatement2"
                        label={i18n.translate('Statement2')}
                    />
                </Box>
                <Box display="flex" justifyContent="space-between" paddingTop={2}>
                    <Button text="Back" color="secondary" onClick={props.onBack} />
                    <Button text="Next" variant="contained" color="primary" onClick={props.onNext}/>
                </Box>
            </Form>
        </Paper>

    )
}

function RegistrationForm_5(props) {
    const theme = useTheme();
    const classes = useStyles();
    const { value, title, description } = props;
    const prompt = usePrompt();

    const handleRequestToken = async () => {
        try {
            await registrationService.sendVerificationCode(value.email);
            prompt.info('Open the email and find the verification code.');
        } catch(e) {
            prompt.alert(e);
        }
    }

    const handleVerifyEmail = async () => {
        try {
            const valid = await registrationService.confirmVerificationCode(value.email, value.token);
            if(valid) {
                props.onChange(new UserEvent({
                    value : {...value, valid: true}
                }));
            }
        } catch(e) {
            prompt.alert('Failed to verify the email.\nPlease try again later.');
        }
    }

    return (
        <Paper padding={3} display="flex" flexDirection="column" gap={1} backgroundOpacity={0.94} borderRadius={1} fullWidth>
            <Typography variant="h5">{ i18n.translate(title)}</Typography>
            <Typography>{i18n.translate(description) + '  email : ' + value.email}</Typography>
            <Box overflowY='auto' overflowX='hidden'>
                <Form value={value} onChange={props.onChange}  maxHeight={`calc(70vh - ${theme.mixins.toolbar.minHeight}px)`}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Button text="Click to get the verification code." color="primary" onClick={handleRequestToken} />
                            <Button color="primary" icon="send" variant="icon" onClick={handleRequestToken} />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField name="token" label="Verification Code" variant="outlined"
                                       fullWidth size="small"
                                       helperText="Please enter the verification code received by email"/>
                        </Grid>
                        <Grid item xs={4}>
                            <Box display="flex" gap={1}>
                                <Checkbox disabled name="valid" />
                                <Button color={"secondary"} variant={'contained'} text="Verify" onClick={handleVerifyEmail}/>
                            </Box>
                        </Grid>
                    </Grid>

                </Form>
            </Box>
            <Typography><span className={classes.whiteSpacePreWrap}>{i18n.translate('Welcome ......')}</span></Typography>
            <Box display="flex" justifyContent="space-between" paddingTop={1}>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Complete" variant="contained" color="primary" onClick={props.onComplete}/>
            </Box>
        </Paper>
    )
}

function RegistrationStepper(props) {
    const classes = useStyles();
    const {activeStep} = props;
    const steps = STEPS;

    return (
        <Stepper className={classes.transparent} activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepLabel><Typography>{i18n.translate(label)}</Typography></StepLabel>
                    <StepContent>
                        <Typography><span className={classes.whiteSpace}>{i18n.translate(getStepContent(index))}</span></Typography>
                    </StepContent>
                </Step>
            ))}
        </Stepper>
    );
}

const registrationDescriptions = [
    {code:'1.', name:'本管理系統為申請『加工食品』之客戶使用，若欲申請『化粧品』或『日用品』請直接來電02-7714-6088洽詢。'},
    {code:'2.', name:'申請評鑑之客戶須為自然人、依法設立或登記之團體、領有公司或商業登記證明文件者、機關(構)、學校或法人。'},
    {code:'3.', name:'本公司『加工食品』評鑑服務範圍排除菸、酒、檳榔、含動物性成分(蛋奶除外)之相關產品。'},
    {code:'4.', name:'如客戶曾涉及非法行為、或有重大不符合評鑑要求之記錄，本公司得就上述之記錄決定是否拒絕受理其評鑑申請。'},
    {code:'5.', name:'經本公司評鑑終止客戶於終止日起1年內不能申請註冊。'}
]

export default withExplorer(Registration);
